import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-8 text-center animate-fade-in">
      <div className="w-16 h-16 rounded-xl bg-grove-100 border border-grove-300 flex items-center justify-center mb-6">
        <Icon className="w-7 h-7 text-bark-400" />
      </div>
      <h3 className="font-display text-lg font-semibold text-bark-700 mb-2">{title}</h3>
      <p className="text-sm text-bark-400 max-w-sm mb-6">{description}</p>
      {action}
    </div>
  );
}
